import type { BoxProps } from "../../../components/layout/box/Box";

export const textContrast = (textColor: string): BoxProps["sx"] => ({
    "h1, h2, h3, h4, h5, p, span": {
        color: textColor,
    },
});
